import React, { Component } from 'react';
import './app.css';
import LinkToEngage from '../components-global/links/LinkToEngage';


//TODO: delete <<
import {
  // trgrRun
  // rearrange
  // restructure
  // createLiveRecord
  // removeArchive
}
  from '../fx/boss';

//TODO: delete >>


class App extends Component {

  //TODO: delete <<
  componentWillMount = () => {
    // return rearrange();
    // return restructure()
    // return trgrRun()
    // return createLiveRecord()
    // return removeArchive();
  };

  //TODO: delete >>

  render() {

    return (
      <div id="a-d1a">
        <div id="a-d2a">
          <LinkToEngage/>
        </div>
      </div>
    );
  };
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App.js